function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import TypographySkeleton from '../Skeleton/Typography';
import renderIf from '@signal/utils/renderIf';
import { Wrapper } from './styles';
export function FeaturedMetricSkeleton(_ref) {
  var noname = _ref.noname,
      titleWidth = _ref.titleWidth,
      metricWidth = _ref.metricWidth,
      rest = _objectWithoutProperties(_ref, ["noname", "titleWidth", "metricWidth"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, renderIf(!noname, function () {
    return /*#__PURE__*/React.createElement(TypographySkeleton, {
      variant: "body4",
      color: "skeletonDark",
      width: titleWidth
    });
  }), /*#__PURE__*/React.createElement(TypographySkeleton, {
    variant: "h1",
    color: "skeletonPrimary",
    width: metricWidth
  }));
}
FeaturedMetricSkeleton.propTypes = {
  noname: PropTypes.bool,
  titleWidth: PropTypes.number,
  metricWidth: PropTypes.number
};
FeaturedMetricSkeleton.defaultProps = {
  titleWidth: 100,
  metricWidth: 280
};
export default FeaturedMetricSkeleton;